export const unloggedRoutes = {
  home: "/",
  login: "/login",
  register: "/register",
  terms: "/terms",
  support: "/support",
  contactUnlogged: "/contact-us",
  pricing: "/pricing",
};

export const loggedRoutes = {
  carPark: "/car-park",
  registerCarParkOwner: "/register-car-park-owner",
  registerCarPar: "/register-car-park",
  bookings: "/",
  requests: "/requests",
  users: "/users",
  userGroups: "/user-groups",
  account: "/account",
  report: "/report",
  showPicture: "/show-picture",
  delete: "/delete",
  edit: "/edit",
  terms: "/terms",
  support: "/support",
  contact: "/contact",
  welcome: "/welcome",
  pricing: "/pricing",
};

export const loggedAndUnloggedRoutes = {
  terms: "/terms",
  support: "/support",
  contact: "/contact",
  pricing: "/pricing",
};
